export enum DiscussionRequestStates {
  WAITING = 'WAITING',
  ACCEPTED = 'ACCEPTED',
  ENDED = 'ENDED',
  HELPING = 'HELPING',
  NOT_SET = 'NOT_SET'
}

export enum DiscussionStateMessages {
  INITIATED = '#initiated',
  INITIATED_ACD = '#initiated_acd',
  ACCEPTED = '#accepted',
  ENDED = '#ended',
  CANCELLED = '#cancelled'
}
